import request from './axios_service'

//TODO: clearly show these are the client requests, and separate lender from client requests in the folder structure

// Get the latest unsubmitted funding request
export const getUnsubmittedFundingRequest = (businessId) => {
  return request({
    url: `/operate/funding_requests?business_id=${businessId}&submitted=false`,
    method: 'GET',
  })
}

export const createNewFundingRequest = (businessId) => {
  return request({
    url: `/operate/funding_requests`,
    method: 'POST',
    data: {
      business_id: businessId,
    },
  })
}

export const createNewFundingRequestWithDetails = (businessId, details) => {
  return request({
    url: `/operate/funding_requests`,
    method: 'POST',
    data: {
      ...details,
      business_id: businessId,
    },
  })
}

export const updateRequestAmount = (requestId, amount) => {
  return request({
    url: `/operate/funding_requests/${requestId}`,
    method: 'PUT',
    data: { amount: amount },
  })
}

export const submitRequest = (requestId) => {
  return request({
    url: `/operate/funding_requests/${requestId}`,
    method: 'PUT',
    data: { submitted: true },
  })
}

//TEMPORTARY FOR DEMO
export const getLastApprovedFundingRequest = (businessId) => {
  return request({
    url: `/operate/funding_requests?business_id=${businessId}&submitted=true&approved=true`,
    method: 'GET',
  })
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - -

export const getAvailabilityData = () => {
  // TODO change static data to server data
  return Promise.resolve({
    unused_availability: 1234567,
    pending_availability: 2345678,
  })
  // return request({
  //     url: '',
  //     method: 'GET'
  // })
}

export const submitAmount = (amount) => {
  // TODO change static data to server data
  return Promise.resolve(true)
  // return request({
  //     url: '',
  //     method: 'POST',
  //     data: {value: amount}
  // })
}
